export const CHARACTER_IMPORT_FILE_FIELD_NAME = "fileUp";
export const CHARACTER_IMPORT_UP_URL = "character/import/file_parse_check";
